import React, { forwardRef, useCallback, useContext } from "react";

import { Skeleton } from "components";
import { ApplicationEntryProgressContext } from "components/contexts";

const RadioButton = (
	{
		id,
		className,
		input,
		meta,
		label,
		disabled,
		tabIndex,
		blurLoading,
		blurWidth,
		blurHeight,
		blurMarginLeft,
		register,
		name,
		...props
	},
	ref,
) => {
	const { triggerSave } = useContext(ApplicationEntryProgressContext);
	const handleBlur = () => {
		input?.onBlur(input.value);
		triggerSave?.();
	};

	const RadioButtonWithLoader = useCallback(
		({ button }) =>
			blurLoading ? (
				<Skeleton
					variant="text"
					width={blurWidth}
					height={blurHeight}
					marginLeft={blurMarginLeft}
				/>
			) : (
				button
			),
		[blurLoading, blurWidth, blurHeight, blurMarginLeft],
	);

	const button = (
		<div className={className}>
			<input
				{...input}
				disabled={disabled}
				id={id}
				type="radio"
				tabIndex={tabIndex}
				{...props}
				onBlur={handleBlur}
			/>
			<label htmlFor={id} className={disabled ? "disabled" : ""}>
				{label}
			</label>
		</div>
	);

	return <RadioButtonWithLoader button={button} />;
};

export default forwardRef(RadioButton);
